import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AccessTokenModal from "../components/AccessTokenModal";
import { teacherMenuItems } from "../components/TeacherMenuItems";
import Videos from "../components/Videos";
import VideoTags from "../components/TeacherVideoTags";
import TeacherProfileNav from "../components/TeacherProfileNav";

// import history from "../images/history.png";
// import tutorials from "../images/tutorials.png";
import TeacherProfileHeader from "../components/TeacherProfileHeader";
// import teacherVideoData from "../components/TeacherVideoData";
import "../styles/TeacherDashboard.css";
import { getToken, getUserID } from "../Storage/Storage";
import { teacherVideos } from "../Services/AllServices";

import TeacherStudentHeader from "../components/TeacherStudentHeader";

const TeacherDashboard = () => {
  const [activeItem, setActiveItem] = useState("home");
  const [isVideoMode, setIsVideoMode] = useState(true);
  const [showUploadForm, setShowUploadForm] = useState(false);
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const [isSearching, setIsSearching] = useState(false);
  const [videoData, setVideoData] = useState([]);
  const [setOpen] = useState(false);
  const [setToken] = useState(null);

  const [copyEnable, setCopyEnable] = useState(false);
  // const location = useLocation();
  // const [hasReloaded, setHasReloaded] = useState(false);

  useEffect(() => {
    setActiveItem("home"); // Set active item to "home" when the dashboard loads
  }, []);
  useEffect(() => {
    if (showUploadForm) {
      navigate("/teacher/upload");
    }
    const fetchTeacherVideos = async () => {
      try {
        const tk = await getToken();
        setToken(tk);
        const userId = await getUserID(); // Fetch user ID from storage
        // Fetch user profile based on user ID
        const formData = { user_id: userId };

        await teacherVideos(formData, (response) => {
          if (response && response.status === "success") {
            // console.log("Teacher Videos:", response);
            if (Array.isArray(response.data.videos_data)) {
              setVideoData(response.data.videos_data);
            } else {
              console.error("Data is not an array:", response);
            }
          }
        });
      } catch (error) {
        console.error("Error fetching videos:", error);
      }
    };

    fetchTeacherVideos();
  });

  const toggleMode = (mode) => {
    setIsVideoMode(mode);
  };

  const handleOpenModal = async () => {
    const t = await getToken(); // Fetch token
    if (t) {
      setToken(t); // Set token
      setOpen(true); // Open modal
    }
  };

  const resetSearch = () => {
    setSearchQuery(""); // Reset the search query
    setIsSearching(false); // Reset search mode
  };

  // Determine which parts of the header to show based on the active menu item
  const getHeaderVisibility = () => {
    if (activeItem === "home" || activeItem === "") {
      return { showSearch: true, showToggle: true, showUserProfile: true };
    } else if (activeItem === "feedback") {
      return { showSearch: false, showToggle: false, showUserProfile: true };
    } else if (activeItem === "tutorials") {
      return { showSearch: true, showToggle: false, showUserProfile: true };
    }
    return { showSearch: false, showToggle: false, showUserProfile: true };
  };
  const { showSearch, showToggle, showUserProfile } = getHeaderVisibility();

  const handleActiveItemChange = (item) => {
    setActiveItem(item); // Update active item

    // Navigate to the correct route
    if (item === "feedback") {
      navigate("/teacherFeedback"); // Navigate to feedback page
    } else if (item === "home") {
      navigate("/teacher"); // Navigate to home page
    } else if (item === "tutorials") {
      navigate("/teacher/tutorials");
    }

    resetSearch(); // Reset search whenever a new section is selected
  };

  const handleSearch = (query) => {
    setSearchQuery(query);
    setIsSearching(query.length > 0); // Show "Search Results" tab if search query exists
    setActiveItem(""); // No active menu item during search
  };

  const filteredVideos = videoData.filter((video) =>
    video.title.toLowerCase().includes(searchQuery.toLowerCase())
  );

  useEffect(() => {
    if (copyEnable) {
      setTimeout(() => {
        setCopyEnable(false);
      }, 2000);
    }
  }, [copyEnable]);

  return (
    <div className="dashboard">
      <TeacherStudentHeader
        isVideoMode={isVideoMode}
        toggleMode={toggleMode}
        showSearch={showSearch}
        showToggle={showToggle}
        showUserProfile={showUserProfile}
        searchQuery={searchQuery}
        onSearch={handleSearch}
        teacherMenuItems={teacherMenuItems}
        activeItem={activeItem} // Pass activeItem
        setActiveItem={handleActiveItemChange}
        onOpenWebVersionModal={handleOpenModal} // Pass setActiveItem
      />
      <main className="main-content">
        {/* <Sidebar
          activeItem={activeItem}
          setActiveItem={handleActiveItemChange}
          menuItems={teacherMenuItems}
          resetSearch={resetSearch}
        /> */}
        <div className="content">
          <div className="teacher_user_profile">
            <TeacherProfileHeader
              showUploadForm={showUploadForm}
              setShowUploadForm={setShowUploadForm}
            />

            <VideoTags />
            <TeacherProfileNav
              setSearchQuery={setSearchQuery}
              setIsSearching={setIsSearching}
              isSearching={isSearching}
              filteredVideos={filteredVideos}
              isDownloadPage={false}
            />
          </div>
          {isSearching ? (
            <Videos videoData={filteredVideos} />
          ) : (
            <Videos videoData={videoData} />
          )}
        </div>
      </main>
      <AccessTokenModal />
    </div>
  );
};

export default TeacherDashboard;
